import React from "react"
import { Table, Popover, Alert, theme as themeConfig, Card } from "antd"
import {
  CommentOutlined,
  FieldTimeOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  DisconnectOutlined,
  UserAddOutlined,
  UserSwitchOutlined,
  LinkOutlined,
  FolderOpenOutlined,
  ProfileOutlined,
  RiseOutlined,
  InfoCircleOutlined,
  PhoneOutlined,
} from "@ant-design/icons"

import "../../../index.scss"

const MetricsTable = ({ item }) => {
  const { token } = themeConfig.useToken()
  const columns = item?.tableData?.columns || []
  const dataSource = item?.tableData?.dataSource || []

  const processColumns = columns => {
    if (!columns || !columns.length) return []

    return columns.map(col => {
      const newCol = {
        ...col,
        width: "auto",
        render: (value) => {
          if (value && typeof value === "object" && "data" in value) {
            const stateClass = value?.attributes?.state
              ? `cell-state-${value?.attributes?.state?.toLowerCase()}`
              : ""

            return (
              <span className={stateClass}>
                {value.data !== undefined ? value.data : "-"}
              </span>
            )
          }
          return value
        },
      }

      if (col.rowSpan && col.rowSpan > 1) {
        const spanSize = col.rowSpan

        newCol.onCell = (_, index) => {
          if (index % spanSize === 0) {
            return { rowSpan: spanSize }
          }
          return { rowSpan: 0 }
        }
      }

      return newCol
    })
  }

  const getIconBasedOnStatType = icon => {
    const icons = {
      message: <CommentOutlined />,
      time: <FieldTimeOutlined />,
      users: <TeamOutlined />,
      done: <CheckCircleOutlined />,
      disconnect: <DisconnectOutlined />,
      assign: <UserAddOutlined />,
      transfer: <UserSwitchOutlined />,
      session: <LinkOutlined />,
      open: <FolderOpenOutlined />,
      total: <ProfileOutlined />,
      progress: <RiseOutlined />,
      call: <PhoneOutlined />,
    }
    return icons[icon] || null
  }

  return (
    <Card
      size="small"
      className="ori-animated ori-fade-in"
      style={{
        border: `1px solid ${token.colorBorderSecondary}`,
        boxShadow: token.boxShadowTertiary,
        background: token.colorBgContainer,
      }}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {getIconBasedOnStatType(item?.icon)}
            {item?.title}
          </span>
          {item?.tooltip?.data?.some(d => d?.description) && (
            <Popover
              trigger="hover"
              placement="bottomRight"
              styles={{
                body: { padding: 0, minWidth: 200 },
                root: { maxWidth: 280 },
              }}
              content={
                <Alert
                  type="info"
                  showIcon
                  style={{ padding: token.paddingXS, fontSize: token.fontSize }}
                  message={
                    <div
                      style={{
                        fontSize: token.fontSize,
                        fontWeight: token.fontWeightStrong,
                      }}
                    >
                      {item?.tooltip?.title}
                    </div>
                  }
                  description={
                    <div
                      style={{
                        fontSize: token.fontSizeSM,
                        marginTop: token.marginXS,
                      }}
                    >
                      {item?.tooltip?.data?.map((tip, index) =>
                        tip?.description ? (
                          <div
                            key={index}
                            style={{ marginBottom: 2, lineHeight: 1.3 }}
                          >
                            {tip?.subtitle ? (
                              <strong>{tip.subtitle}</strong>
                            ) : null}
                            {tip?.subtitle && tip?.description ? ": " : ""}
                            {tip?.description}
                          </div>
                        ) : null
                      )}
                    </div>
                  }
                />
              }
            >
              <InfoCircleOutlined
                style={{
                  color: token.colorTextDescription,
                  cursor: "pointer",
                  fontSize: token.fontSizeSM,
                }}
              />
            </Popover>
          )}
        </div>
      }
    >
      <Table
        bordered     
        columns={processColumns(columns)}
        dataSource={dataSource}
        pagination={false}
        size="small"
        scroll={{ y: 300 }}
      />
    </Card>
  )
}

export default MetricsTable
